<template>
  <v-section
    :lines="2"
    class="c-section--two-lines"
  >
    <template #default="{ products }">
      <ui-tile
        v-for="(parsed) in parsedProducts(products)"
        :key="parsed[0].id"
        :products-array="parsed"
        :layout="TileLayout.TRAILER"
      ></ui-tile>
    </template>
    <template #headerLeft>
      <slot name="headerLeft"></slot>
    </template>
    <template #headerRight>
      <slot name="headerRight"></slot>
    </template>
  </v-section>
</template>
<script>
  import { TileLayout } from '@/shared/enums';
  import { VSection } from '@/index/shared/components';
  import UiTile from '../../tile/index.vue';

  export default {
    components: {
      UiTile,
      VSection,
    },
    enums: {
      TileLayout,
    },
    inject: ['$section'],
    methods: {
      parsedProducts(products) {
        const newArray = [];
        const elements = products.length
          ? products
          : this.$section.resource.elements.collection.records;

        for (let i = 0, index = 0; i < elements.length; i++, index = Math.floor(i / 2)) {
          if (i % 2) {
            newArray[index][1] = elements[i];
          } else {
            newArray[index] = [elements[i]];
          }
        }
        return newArray;
      },
    },
  };
</script>
